import React, { useState } from 'react'
import useSWR from 'swr'
import fetcher from '@lib/fetcher'
import ItemRow from './item-row'

const MIN_QUERY_LENGTH = 2

// Searches `${url}?q=<term>` and offers matches not already in the slideshow.
const ItemSearch = ({ id, label, placeholder, url, emptyText, isSelected, onAdd }) => {
  const [query, setQuery] = useState('')
  const term = query.trim()
  const { data, isLoading } = useSWR(
    url && term.length >= MIN_QUERY_LENGTH ? `${url}?q=${encodeURIComponent(term)}` : null,
    fetcher
  )
  const results = Array.isArray(data) ? data.filter(item => !isSelected(item)) : null

  return (
    <div>
      <label htmlFor={id} className='text-sm font-medium text-gray-700 dark:text-gray-300'>{label}</label>
      <input
        id={id}
        type='search'
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        // Enter searches as you type; don't let it submit the slideshow form
        onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault() }}
        placeholder={placeholder}
        className='mt-1 block w-full px-3 py-2 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm'
      />
      {term.length >= MIN_QUERY_LENGTH && (
        <ul className='divide-y divide-gray-200 dark:divide-gray-700'>
          {results?.map(item => (
            <ItemRow key={`${item.type}:${item.id}`} item={item}>
              <button type='button' onClick={() => onAdd(item)} className='px-3 py-1 rounded-md text-sm font-medium bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white dark:text-white'>
                Add
              </button>
            </ItemRow>
          ))}
          {isLoading && !results && (
            <li className='py-2 text-sm text-gray-500 dark:text-gray-400'>Searching…</li>
          )}
          {results?.length === 0 && (
            <li className='py-2 text-sm text-gray-500 dark:text-gray-400'>{emptyText}</li>
          )}
        </ul>
      )}
    </div>
  )
}

export default ItemSearch
